import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import { IDE_TYPE } from "../../../constants/common";
import lessonServices from "../../../services/lessonServices";
import studentServices from "../../../services/studentServices";
import Button from "../../Button";
import TeacherPythonIDEWrapper from "../../IDEs/wrappers/teacher/TeacherPythonIDEWrapper";
import TeacherSmoothyIDEWrapper from "../../IDEs/wrappers/teacher/TeacherSmoothyIDEWrapper";
import TeacherWebIDEWrapper from "../../IDEs/wrappers/teacher/TeacherWebIDEWrapper";
import Modal from "../../Modal";

const CodeNotificationSubmissionsModal = forwardRef(({ selectedProgram, onSubmit }, ref) => {
  const { t } = useTranslation();

  const [IDEType, setIDEType] = useState("");
  const [selectedLessonID, setSelectedLessonID] = useState("");
  const [selectedProjectID, setSelectedProjectID] = useState("");
  const [challengeData, setChallengeData] = useState(null);
  const [lessonName, setLessonName] = useState("");
  const [studentName, setStudentName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [codeData, setCodeData] = useState(null);

  useImperativeHandle(ref, () => ({
    openModal(lessonID, action_by) {
      setSelectedLessonID(lessonID);
      setIDEType("");
      setStudentName(action_by);

      setSelectedProjectID("");
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const getCodeSolution = async () => {
    try {
      const response = await studentServices.getStudentProject(selectedLessonID);
      setIDEType(response?.code_type);
      setCodeData(response);
      if (response.lesson_project_id && response.difficulty) {
        getProjectGoal(response.lesson_project_id);
        setSelectedProjectID(response.lesson_project_id);
      } else if (response.lesson_project_id && !response.difficulty) {
        getProjectGoal(response.lesson_project_id);
        setSelectedProjectID(response.lesson_project_id);
      } else {
        setChallengeData(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onSubmitTwo = () => {
    getCodeSolution();
    onSubmit();
  };

  const getProjectGoal = async (id) => {
    try {
      const response = await lessonServices.getLessonProject(id, { type: selectedProgram });
      setChallengeData(response);
    } catch (error) {
      console.error("Error fetching project goal:", error);
    }
  };

  useEffect(() => {
    if (isOpen && selectedLessonID) {
      getCodeSolution();
    }
  }, [selectedLessonID, isOpen]);

  return (
    <Modal
      isFullScreen
      isOpen={isOpen}
      onClose={handleCloseModal}
      footer={
        <div className="flex justify-end">
          <Button variant="text" onClick={handleCloseModal} label={t("close")} />
        </div>
      }
    >
      {codeData && IDEType === IDE_TYPE.SMOOTHY && (
        <TeacherSmoothyIDEWrapper
          onSubmit={onSubmitTwo}
          type="submissions"
          codeData={codeData}
          lessonName={lessonName}
          lessonID={selectedProjectID}
          studentName={studentName}
          isPlaygroundProject={!codeData.lesson_project_id}
          projectGoal={{
            projectGoal: challengeData?.challenge_statement,
            name: challengeData?.name,
            image: challengeData?.image,
          }}
        />
      )}

      {codeData && IDEType === IDE_TYPE.WEB && (
        <TeacherWebIDEWrapper
          onSubmit={onSubmitTwo}
          type="submissions"
          codeData={codeData}
          lessonName={lessonName}
          lessonID={selectedProjectID}
          studentName={studentName}
          isPlaygroundProject={!codeData.lesson_project_id}
          projectGoal={{
            projectGoal: challengeData?.challenge_statement,
            name: challengeData?.name,
            image: challengeData?.image,
          }}
        />
      )}

      {codeData && IDEType === IDE_TYPE.PYTHON && (
        <TeacherPythonIDEWrapper
          onSubmit={onSubmitTwo}
          type="submissions"
          codeData={codeData}
          lessonName={lessonName}
          lessonID={selectedProjectID}
          studentName={studentName}
          isPlaygroundProject={!codeData.lesson_project_id}
          projectGoal={{
            projectGoal: challengeData?.challenge_statement,
            name: challengeData?.name,
            image: challengeData?.image,
          }}
        />
      )}
    </Modal>
  );
});

export default CodeNotificationSubmissionsModal;
